import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "select-none pr-4"
}
const _hoisted_2 = { class: "font-bold text-sm leading-6" }
const _hoisted_3 = { class: "mt-1 text-sm psi-input-text" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "sr-only" }
const _hoisted_6 = {
  key: 0,
  class: "text-sm text-red-500 mt-2"
}

import { computed } from 'vue';
import { Switch } from "@headlessui/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleSwitch',
  props: {
    value: {
        default: null,
        required: true,
    },
    label: {
        type: String,
        default: null,
    },
    description: {
        type: String,
        default: null,
    },
    noPadding: {
        type: Boolean,
        default: false
    },
    error: {
        type: String,
        default: null,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
},
  emits: ['change'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit
const switchValue = computed ({
    get() {
        return props.value;
    },
    set(value) {
        emit('change', value);
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.disabled ? 'cursor-not-allowed' : 'cursor-pointer')
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex items-center rounded transition", [
                __props.noPadding ? 'justify-start !py-0 !px-0 w-min' : 'justify-between py-5 px-6 border',
                __props.error ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : 'border-gray-100 focus:border-primary-600 focus:ring-primary-600',
                __props.disabled ? 'pointer-events-none bg-gray-50' : '',
            ]]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change', !__props.value)))
    }, [
      (__props.label || __props.description)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("h5", _hoisted_2, _toDisplayString(__props.label), 1),
            _createElementVNode("p", _hoisted_3, _toDisplayString(__props.description), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Switch), {
          modelValue: switchValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((switchValue).value = $event)),
          class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full transition pointer-events-none", [
                        switchValue.value ? 'bg-primary-600' : 'bg-gray-300',
                        __props.disabled ? 'text-gray-200' : '',
                    ]])
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_5, _toDisplayString(__props.label), 1),
            _createElementVNode("span", {
              class: _normalizeClass([switchValue.value ? 'translate-x-6' : 'translate-x-1', "inline-block h-4 w-4 transform rounded-full bg-white transition"])
            }, null, 2)
          ]),
          _: 1
        }, 8, ["modelValue", "class"]),
        _renderSlot(_ctx.$slots, "default")
      ])
    ], 2),
    (__props.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(__props.error), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})